import React, {
    useEffect,
    useState,
  } from "react";
  import { Link } from "react-router-dom";
  import Collapse from "react-bootstrap/Collapse"; /// Link
import { NavMenuToggle } from "./NavHader";
  
  const UserSidebar = ({ state, setState, menuListData }) => {
    const [loginDetails, setLoginDetails] = useState(null);
      
    const token =
      localStorage.getItem("access_token_user") ||
      localStorage.getItem("access_token_admin");

    useEffect(() => {
      let loginDetailsRaw = localStorage.getItem("login_Details");
      if (loginDetailsRaw) {
        try {
          setLoginDetails(JSON.parse(loginDetailsRaw));
        } catch (e) {
          console.warn("Invalid login_Details JSON:", e);
        }
      } else if (token) {
        fetch(`${process.env.REACT_APP_BASE_URL}/profile`, {
          headers: { Authorization: `Bearer ${token}` },
        })
          .then((res) => {
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            return res.json();
          })
          .then((profile) => {
            localStorage.setItem("login_Details", JSON.stringify(profile));
            setLoginDetails(profile);
          })
          .catch((err) => console.error("Failed to fetch /profile:", err));
      }
    }, [token]);
    
    const { name, email, user } = loginDetails || {};
    const userLevel = user?.user_level;
    const categoryTypeFromStorage = Number(localStorage.getItem("category_type"));
    const categoryTypeFromPayload = Number(
      user?.category_type ??
      user?.sub_category_type ??
      loginDetails?.category_type ??
      loginDetails?.sub_category_type
    );
    const effectiveCategoryType =
      Number.isFinite(categoryTypeFromStorage) && categoryTypeFromStorage > 0
        ? categoryTypeFromStorage
        : categoryTypeFromPayload;

    const isSupportStaffUser = effectiveCategoryType === 2;
    let path = window.location.pathname;
    path = path.split("/");
    path = path[path.length - 1];

    const formMatch  = window.location.pathname.match(/^\/grant-scheme\/form\/(.+)$/);
    const descMatch  = window.location.pathname.match(/^\/grant-scheme\/description\/(.+)$/);
    const isGrantSchemedescMatch = window.location.pathname.match(/^\/grant-scheme/);

    useEffect(()=>{
      if(path==="user-grievance-management/ticket" ||
        path === "user-grievance-management/notification"){
        setState({ active: "Grievance Management" });
      }
      else if(formMatch || descMatch || isGrantSchemedescMatch){
        setState({ active: "Schemes & Scholarship" });
      }else{
        const fullPath = window.location.pathname.replace(/^\//, "");
        const activeMenu = (menuListData || []).find(menu =>
          menu.content?.some(item =>
            fullPath === item.to ||
            fullPath.startsWith(item.to + "/") ||
            item.content?.some(sub =>
              fullPath === sub.to || fullPath.startsWith(sub.to + "/")
            )
          )
        );
        setState({ active: activeMenu?.title || "" });
      }
    },[path, menuListData]);
    

    // console.log("path======>",path);
    // console.log("menuListData======>",menuListData);
  
    const handleMenuActive = (status) => {
      setState({ active: status });
      if (state.active === status) {
        setState({ active: "" });
      }
    };
    const handleSubmenuActive = (status) => {
      setState({ activeSubmenu: status });
      if (state.activeSubmenu === status) {
        setState({ activeSubmenu: "" });
      }
    };

    const shouldShareLoginDetails = (menuTitle) => {
      const menusRequiringLogin = [
        "Inventory Management",
        "Communication Management",
        "Assessment Management",
        "Scouting Management",
        "Inventory",
        "Venue Infra",
        "Scheme Management",
        "TMS Management",
        "DIGI ACCRED Management",
        "Service Provider Management",
        "LMS Management",
        "Hostel Management",
        "Ticket Management System",
        "Project Management",
        "Grant Schemes",
      ];
      return menusRequiringLogin.includes(menuTitle);
    };

    const setLMSCookies = () => {
      const freshToken = localStorage.getItem("access_token_user") || localStorage.getItem("access_token_admin");
      if (!freshToken) {
        console.warn("LMS: No token found in localStorage");
        return;
      }

      const freshLoginDetailsRaw = localStorage.getItem("login_Details");
      if (!freshLoginDetailsRaw) {
        console.warn("LMS: No login_Details found in localStorage");
        return;
      }

      const freshLoginDetails = JSON.parse(freshLoginDetailsRaw);
      const detailsUser = freshLoginDetails?.user || {};
      
      const name = freshLoginDetails?.name || detailsUser?.name || "User";
      const email = freshLoginDetails?.email || detailsUser?.email || "";

      const hostname = window.location.hostname;
      // Only set domain if on khelouk.in, otherwise leave it off for localhost
      const domain = hostname.includes("khelouk.in") ? ".khelouk.in" : "";
      const expires = new Date(Date.now() + 2 * 24 * 60 * 60 * 1000).toUTCString(); // 2 days
      
      const cookieBase = `path=/; expires=${expires}; SameSite=Lax`;
      const domainPart = domain ? `; domain=${domain}` : "";

      document.cookie = `access_token=${freshToken}; ${cookieBase}${domainPart}`;
      document.cookie = `session=${email}; ${cookieBase}${domainPart}`;
      document.cookie = `user_first_name=${name}; ${cookieBase}${domainPart}`;
      
      let role = "user";
      // Check category_type/sub_category_type (1 for student, 2 for teacher/coach)
      const categoryType = Number(detailsUser?.category_type || detailsUser?.sub_category_type || freshLoginDetails?.category_type || freshLoginDetails?.sub_category_type);
      const userCategoryMain = Number(detailsUser?.user_category_main || freshLoginDetails?.user_category_main);

      if (categoryType === 2) {
        role = "coach"; 
      } else if (categoryType === 1) {
        role = "student";
      } else if (userCategoryMain === 2) {
        role = "admin";
      }
      
      document.cookie = `user_role=${role}; ${cookieBase}${domainPart}`;
      console.log("LMS Cookies Set Successfully with role:", role);
    };

    useEffect(() => {
      if (loginDetails && token) {
        setLMSCookies();
      }
    }, [loginDetails, token]);

    // const buildUrlWithLoginParams = (baseUrl, includeCompleteUserDetails = false, menuTitle = "") => {
    //   if (!token) return baseUrl;

    //   const params = new URLSearchParams();
      
    //   params.append("access_token", token);

    //   if (includeCompleteUserDetails && loginDetails) {
    //     params.append("login_details", JSON.stringify(loginDetails));
    //   } else {
    //     if (name) params.append("name", name);
    //     if (email) params.append("email", email);
    //     if (userLevel) params.append("user_level", userLevel);
    //   }

    //   const paramString = params.toString();
    //   return baseUrl + (baseUrl?.includes("?") ? `&${paramString}` : `?${paramString}`);
    // };
       const buildUrlWithLoginParams = (
  baseUrl,
  includeCompleteUserDetails = false,
  menuTitle = ""
) => {

  /*
  if (!token) return baseUrl;

  const params = new URLSearchParams();

  params.append("access_token", token);

  if (includeCompleteUserDetails && loginDetails) {
    params.append("login_details", JSON.stringify(loginDetails));
  } else {
    if (name) params.append("name", name);
    if (email) params.append("email", email);
    if (userLevel) params.append("user_level", userLevel);
  }

  const paramString = params.toString();
  return (
    baseUrl + (baseUrl?.includes("?") ? `&${paramString}` : `?${paramString}`)
  );
  */

  return baseUrl;
};
    const filteredMenuListData = (menuListData || []).filter((menu) => {
      // Only support staff should see Service Provider module in user sidebar.
      if (menu?.title === "Service Provider Management") {
        return isSupportStaffUser;
      }
      return true;
    });
    // CLOSE THE SIDE BAR ONCE CLICK THE SUBMENU
      const handleMobileSidebarClose = () => {
      if (window.innerWidth <= 1024) {
        NavMenuToggle();
      }
     };

    return (
      <>
        {filteredMenuListData?.map((data, index) => {
          let menuClass = data.classsChange;
          if (menuClass === "menu-title") {
            return (
              <li className={menuClass} key={index}>
                {data.title}
              </li>
              
            );
          } else {
            return (
              <li
                className={` ${state.active === data.title ?"mm-active" : ""}`}
                key={index}
              >
                {data.content && data.content.length > 0 ? (
                  <>
                    <Link
                      to={"#"}
                      className="has-arrow"
                      onClick={() => {
                        handleMenuActive(data.title);
                      }}
                    >
                      {data.iconStyle}{" "}
                      <span className="nav-text">
                        {data?.title}
                        {data?.update && data?.update?.length > 0 ? (
                          <span className="badge badge-xs badge-danger ms-2">
                            {data?.update}
                          </span>
                        ) : (
                          ""
                        )}
                      </span>
                    </Link>
                    <Collapse in={state.active === data.title ? true : false}>
                      <ul
                        className={`${
                          menuClass === "mm-collapse" ? "mm-show" : ""
                        }`}
                      >
                        {data.content &&
                          data.content.map((item, index) => {
                            let url = item.to;
                            if (shouldShareLoginDetails(data.title)) {
                              url = buildUrlWithLoginParams(url, true, data.title);
                            }
                            return (
                              <li
                                key={index}
                                className={`${
                                  state.activeSubmenu === item.title
                                    ? "mm-active"
                                    : ""
                                }`}
                              >
                                {item.content && item.content.length > 0 ? (
                                
                                  <>
                                    <Link
                                      to={url}
                                      className={item.hasMenu ? "has-arrow" : ""}
                                      onClick={() => {
                                        handleSubmenuActive(item.title);
                                      }}
                                    >
                                      {item.title}
                                    </Link>
                                    <Collapse
                                      in={
                                        state.activeSubmenu === item.title
                                          ? true
                                          : false
                                      }
                                    >
                                      <ul
                                        className={`${
                                          menuClass === "mm-collapse"
                                            ? "mm-show"
                                            : ""
                                        }`}
                                      >
                                        {item.content &&
                                          item.content.map((subItem, index) => {
                                            let subUrl = subItem.to;
                                            if (shouldShareLoginDetails(data.title)) {
                                              subUrl = buildUrlWithLoginParams(subUrl, true, data.title);
                                            }
                                            
                                              return (
                                                <li key={index}>
                                                  {subUrl.startsWith("http") ? (
                                                    <a
                                                      href={subUrl}
                                                      className={`${
                                                        path === subItem.to
                                                          ? "mm-active"
                                                          : ""
                                                      }`}
                                                      onClick={() => {
                                                        handleMobileSidebarClose(); 
                                                        if (data.title === "LMS Management") {
                                                          setLMSCookies();
                                                        }
                                                        
                                                      }}
                                                    >
                                                      {subItem.title}
                                                    </a>
                                                  ) : (
                                                    <Link
                                                      className={`${
                                                        path === subItem.to
                                                          ? "mm-active"
                                                          : ""
                                                      }`}
                                                      onClick={handleMobileSidebarClose}
                                                      to={subUrl}
                                                    >
                                                      {subItem.title}
                                                    </Link>
                                                  )}
                                                </li>
                                              );
                                          })}
                                      </ul>
                                    </Collapse>
                                  </>
                                ) : (
                                  
                                  <Link 
                                    to={url}
                                    onClick={() => {
                                      handleMobileSidebarClose();
                                      if (data.title === "LMS Management") {
                                        setLMSCookies();
                                      }
                                    }}
                                  >
                                    {item.title}
                                  </Link>
                                  
                                )}
                              </li>
                            );
                          })}
                      </ul>
                    </Collapse>
                  </>
                ) : (
                  <>
                    {(shouldShareLoginDetails(data.title) ? buildUrlWithLoginParams(data.to, true, data.title) : data.to).startsWith("http") ? (
                      <a
                        href={shouldShareLoginDetails(data.title) ? buildUrlWithLoginParams(data.to, true, data.title) : data.to}
                        onClick={() => {
                          handleMenuActive(data.title);
                          if (data.title === "LMS Management") {
                            setLMSCookies();
                          }
                          if(data.title=="Schemes & Scholarship"){
                            localStorage.setItem("activeTab", "schemes");
                          }
                           handleMobileSidebarClose();
                        }}
                      >
                        {data.iconStyle}
                        <span className="nav-text">{data.title}</span>
                      </a>
                    ) : (
                      <Link 
                        to={data.to} 
                        onClick={() => {
                          handleMenuActive(data.title);
                          if(data.title=="Schemes & Scholarship"){
                            localStorage.setItem("activeTab", "schemes");
                          }
                           handleMobileSidebarClose();
                        }}
                      >
                        {data.iconStyle}
                        <span className="nav-text">{data.title}</span>
                      </Link>
                    )}
                  </>
                )}
              </li>
            );
          }
        })}
      </>
    );
  };
  
  export default UserSidebar;
  